import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';

@Component({ standalone: false,
  selector: 'vfa-cp-auth-otp-form',
  templateUrl: './auth-otp-form.component.html',
  styleUrls: ['./auth-otp-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthOtpFormComponent implements OnChanges {
  @Output() validateOtp: EventEmitter<any> = new EventEmitter();
  @Output() askNewOtp: EventEmitter<any> = new EventEmitter();
  @Input() newOtp: any;
  @Input() title: any = null;
  @Input() subtitle: any;
  @Input() waitOtp: any;
  @Input() isError: any;
  form!: FormGroup;
  req: any = { input1: "", input2: "", input3: "", input4: "", input5: "", input6: "" };
  formInput = ['input1', 'input2', 'input3', 'input4', 'input5', 'input6'];
  private KEY = 'time';
  private EVENT_KEY = 'exp-otp';
  public counter = "0";
  public waitCounter = true;
  private intervalTimer: any;
  private regexOTP = new RegExp("[0-9]");
  public token = '';
  private formRow1: any;
  private formRow2: any;
  private formRow3: any;
  private formRow4: any;
  private formRow5: any;
  private formRow6: any;
  @ViewChildren('formRow1') set inputF(inputF: any) {
    this.formRow1 = inputF;
    this.formRow1.first?.nativeElement?.focus();
  }
  @ViewChildren('formRow2') set inputF2(inputF: any) {
    this.formRow2 = inputF;
  }
  @ViewChildren('formRow3') set inputF3(inputF: any) {
    this.formRow3 = inputF;
  }
  @ViewChildren('formRow4') set inputF4(inputF: any) {
    this.formRow4 = inputF;
  }
  @ViewChildren('formRow5') set inputF5(inputF: any) {
    this.formRow5 = inputF;
  }
  @ViewChildren('formRow6') set inputF6(inputF: any) {
    this.formRow6 = inputF;
  }

  constructor(private formBuilder: FormBuilder, private cdr: ChangeDetectorRef) {
  }

  ngOnChanges(changes: any) {
    if (changes && changes.newOtp  && changes.newOtp.currentValue) {
      this.destroyReq();
      this.createForm();
      this.startMomentCountdown(changes.newOtp.currentValue.expiration_timestamp || this.newOtp.expiration_timestamp || this.newOtp.last_request_expiration_timestamp);
    }
    if (changes && changes.waitOtp && changes.waitOtp.currentValue) {
      this.waitOtp = changes.waitOtp.currentValue;
    }
    if(changes && changes.isError && changes.isError.currentValue){
      this.isError = changes.isError.currentValue;
      if(this.isError) {
        this.destroyReq();
        this.formRow1.first?.nativeElement?.focus();
      }
    }
  }

  private destroyReq() {
    if(this.req.input1 || this.req.input2 || this.req.input3 || this.req.input4 || this.req.input5 || this.req.input6) {
      this.req.input1 = "";
      this.req.input2 = "";
      this.req.input3 = "";
      this.req.input4 = "";
      this.req.input5 = "";
      this.req.input6 = "";
    }
  }

  public sendNewOtp() {
    this.askNewOtp.emit();
  }

  private startMomentCountdown(expDate: any) {
    this.waitCounter = true;
    let expirationTime = moment.unix(expDate)
    localStorage.setItem(this.EVENT_KEY, String(expirationTime));
    let currentTime = moment();
    // start countdown
    this.intervalTimer = setInterval(() => {
      currentTime = moment();
      expirationTime = moment(localStorage.getItem(this.EVENT_KEY));
      const remaining = expirationTime.diff(currentTime);
      if (remaining < 0) {
        clearInterval(this.intervalTimer);
        localStorage.removeItem(this.KEY)
        localStorage.removeItem(this.EVENT_KEY)
        this.counter = '';
        this.blurAll();
        this.form.disable();
        this.cdr.detectChanges();
        this.waitCounter = false;
      } else {
        const currentExp = moment.utc(expirationTime.diff(currentTime)).format("mm'ss''");
        this.counter = currentExp;
        localStorage.setItem(this.KEY, currentExp);
        this.cdr.detectChanges()
        this.waitCounter = false;
      }
    }, 1000);
  }

  createForm() {
    this.form = this.formBuilder.group({
      input1: [{value: this.req.input1, disabled: this.waitOtp}, [Validators.required]],
      input2: [{value: this.req.input2, disabled: this.waitOtp}, [Validators.required]],
      input3: [{value: this.req.input3, disabled: this.waitOtp}, [Validators.required]],
      input4: [{value: this.req.input4, disabled: this.waitOtp}, [Validators.required]],
      input5: [{value: this.req.input5, disabled: this.waitOtp}, [Validators.required]],
      input6: [{value: this.req.input6, disabled: this.waitOtp}, [Validators.required]],
      // newOtpInput: ['', [Validators.required]],
    });

  }

  public keyUpEvent(event: any, index?: any) {
    const eventText = event.key && event.key !== 'Unidentified' ? event.key : event.target?.value;
    if(eventText.length === 6) {
      event.preventDefault();
      this.onPasteData(eventText);
      this.next();
    } else {
      const eventTextLastChar = eventText.substring(eventText.length - 1);
      const eventTextTrim = eventText.trim();
      const nextElement = document.getElementById('formRow' + (index + 1));
      const prevElement = document.getElementById('formRow' + (index - 1));
      if (eventText === "Backspace") {
        this.req["input" + index] = '';
        if (prevElement) {
          prevElement.focus();
          return;
        } else {
          return;
        }
      } else if (eventText === "Enter" || eventText === "ArrowRight" || eventText === " " || eventText === "TAB" || eventText === "Tab" || eventText === "Control") {
        this.req["input" + index] = event.target.value = this.req["input" + index].trim();
        if (nextElement && eventText !== "TAB" && eventText !== "Tab") {
          nextElement.focus();
          return;
        } else {
          return;
        }
      } else if (eventText === "ArrowLeft") {
        if (prevElement) {
          prevElement.focus()
          return;
        } else {
          return;
        }
      } else if (eventText === "Shift") {
        return;
      }
      if (eventText.length === 1 && (eventText.match(this.regexOTP))) {
        if(this.req["input" + index].length === 0) {
          this.req["input" + index] = eventText;
        } else {
          if(this.req["input" + index]) {
            this.req["input" + index] = event.target.value = eventTextLastChar;
          } else {
            event.target.value = this.req["input" + index] = '';
          }
        }
        this.next();
        if (nextElement) {
          nextElement.focus()
          return;
        }
      } else {
        if(this.req["input" + index]) {
          if(eventTextLastChar.length === 0 && eventTextTrim.length === 0) {
            this.req["input" + index] = event.target.value = '';
            if (prevElement) {
              prevElement.focus();
              return;
            } else {
              return;
            }
          } else if(eventTextTrim.length === 1) {
            this.req["input" + index] = event.target.value = eventTextTrim;
          } else {
            this.req["input" + index] = event.target.value = eventTextLastChar;
          }
          if (nextElement) {
            nextElement.focus()
            return;
          }
        } else if(eventText.match(this.regexOTP)) {
          event.preventDefault();
          this.onPasteData(eventText);
          const focusedElement = document.getElementById('formRow' + eventText.length);
          focusedElement?.focus();
        } else {
          this.req["input" + index] = event.target.value = '';
        }
      }
    }
  }

  onPaste(event: any){
    event.preventDefault();
    const codeText = event.clipboardData.getData('text');
    this.onPasteData(codeText);
    this.next();
  }

  onPasteData(codeText: string) {
    this.req.input1 = codeText[0] ? codeText[0] : "";
    this.req.input2 = codeText[1] ? codeText[1] : "";
    this.req.input3 = codeText[2] ? codeText[2] : "";
    this.req.input4 = codeText[3] ? codeText[3] : "";
    this.req.input5 = codeText[4] ? codeText[4] : "";
    this.req.input6 = codeText[5] ? codeText[5] : "";
  }

  get f(): any {
    return this.form.controls;
  }

  next() {
    const keys = Object.keys(this.req);
    const found = keys.filter(key => !this.req[key]);
    if(!found || !found.length) {
      let ret = '';
      const values: any[] = [];
      this.formInput.forEach(i => {
        values.push(this.req[i]);
      });
      values.forEach(v => {
        ret += v ? v : 0;
      });
      ret = ret.toUpperCase();
      const req = {
        "otp": ret
      }
      if(ret.length === 6) {
        this.blurAll();
        this.validateOtp.emit(req) 
      }
    }
  }

  private blurAll() {
    this.formRow1.first?.nativeElement?.blur();
    this.formRow2.first?.nativeElement?.blur();
    this.formRow3.first?.nativeElement?.blur();
    this.formRow4.first?.nativeElement?.blur();
    this.formRow5.first?.nativeElement?.blur();
    this.formRow6.first?.nativeElement?.blur();
  }

  public selectionEnd(event: any) {
    if(event?.target?.value?.length) {
      const tempValue = event.target.value;
      event.target.value = "";
      event.target.value = tempValue;
    }
  }
}

